import { OrderStatus, OrderItemStatus } from '../config/enums'
import { Order } from '../models/Order'
import { formatToPrice } from './prettifynumber'
import { convertDateFormat } from './stringUtils'

export const friendlyOrderStatus = (status: OrderStatus) => {
  let friendlyStatus = 'Unknown'
  switch (status) {
    case OrderStatus.placed:
      friendlyStatus = 'Order placed'
      break
    case OrderStatus.approved:
      friendlyStatus = 'Order approved'
      break
    case OrderStatus.closed:
      friendlyStatus = 'Order closed'
      break
    case OrderStatus.rejected:
      friendlyStatus = 'Order rejected'
      break
  }
  return friendlyStatus
}

export const friendlyOrderItemStatus = (status: OrderItemStatus) => {
  let friendlyStatus = 'Unknown'
  switch (status) {
    case OrderItemStatus.placed:
      friendlyStatus = 'Order placed'
      break
    case OrderItemStatus.processing:
      friendlyStatus = 'Processing order'
      break
    case OrderItemStatus.disptached:
      friendlyStatus = 'Order dispatched'
      break
    case OrderItemStatus.delivered:
      friendlyStatus = 'Order delivered'
      break
    case OrderItemStatus.canceled:
      friendlyStatus = 'Order canceled'
      break
    case OrderItemStatus.rejected:
      friendlyStatus = 'Order rejected'
      break
  }
  return friendlyStatus
}

export interface OrderRow {
  id: string
  orderNumber: string
  customer: string
  country: string
  amount: string
  created: string
  status: string
}

export const ordersToOrderRows = (orders: Order[], vendorId: string) => {
  const orderRows: OrderRow[] = []
  orders.forEach(order => {
    let formattedDate = ''
    if (order.createdAt) {
      formattedDate = convertDateFormat(order.createdAt)
    }

    let customerName = ''
    if (order.biller) {
      customerName = `${order.biller.firstName} ${order.biller.lastName}`
    }

    let deliveryCountry = ''
    if (order.recipient) {
      deliveryCountry = order.recipient.address.country
    }

    let amount = 0
    let statuses: string[] = []
    order.orderItems
      .filter(o => o.vendor.id === vendorId)
      .forEach(oItem => {
        amount += oItem.totalPrice
        statuses.push(friendlyOrderItemStatus(oItem.status))
      })

    orderRows.push({
      id: order.id,
      orderNumber: order.orderNumber,
      customer: customerName,
      country: deliveryCountry,
      amount: formatToPrice(amount),
      created: formattedDate,
      status: statuses.join('\n')
    })
  })
  return orderRows
}
